<template>
  <div class="row for-authors-policies">
    <!--Non-Mobile Only-->
    <div class="col-md-3 hidden-sm-down">
      <for-authors-page-side-menu :anchors-list="menuAnchorsList"></for-authors-page-side-menu>
    </div>
    <!--Non-Mobile Only-->
    <div class="col-md">
      <for-authors-ethics-malpractice-content :anchors-list="menuAnchorsList"  :id="menuAnchorsList[0].anchor"></for-authors-ethics-malpractice-content>
      <for-authors-copyright-licensing-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[1].anchor"></for-authors-copyright-licensing-content>
      <for-authors-peer-review-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[2].anchor"></for-authors-peer-review-content>
      <for-authors-plagerism-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[3].anchor"></for-authors-plagerism-content>
      <for-authors-processing-fee-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[4].anchor"></for-authors-processing-fee-content>
      <for-authors-archiving-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[5].anchor"></for-authors-archiving-content>
    </div>
  </div>
</template>

<script>
  import ForAuthorsPageSideMenu from '@/components/for-authors/ForAuthorsPageSideMenu'
  import ForAuthorsProcessingFeeContent from '@/components/for-authors/for-authors-policies/ProcessingFeeContent'
  import ForAuthorsPlagerismContent from '@/components/for-authors/for-authors-policies/PlagerismContent'
  import ForAuthorsPeerReviewContent from '@/components/for-authors/for-authors-policies/PeerReviewContent'
  import ForAuthorsEthicsMalpracticeContent from '@/components/for-authors/for-authors-policies/EthicsMalpracticeContent'
  import ForAuthorsCopyrightLicensingContent from '@/components/for-authors/for-authors-policies/CopyrightLicensingContent'
  import ForAuthorsArchivingContent from '@/components/for-authors/for-authors-policies/ArchivingContent'

  export default {
    components: {
      ForAuthorsPageSideMenu,
      ForAuthorsProcessingFeeContent,
      ForAuthorsPlagerismContent,
      ForAuthorsPeerReviewContent,
      ForAuthorsEthicsMalpracticeContent,
      ForAuthorsCopyrightLicensingContent,
      ForAuthorsArchivingContent
    },
    name: 'for-authors-policies',
    data () {
      return {
        menuAnchorsList: [
          {anchor: 'ethic', name: 'Ethics & Malpractice'},
          {anchor: 'copyright', name: 'Copyright & Licensing'},
          {anchor: 'peer-review', name: 'Peer Review'},
          {anchor: 'plagerism', name: 'Plagerism'},
          {anchor: 'processing-fee', name: 'Processing Fee'},
          {anchor: 'archiving', name: 'Archiving'}
        ]
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ForAuthorsPoliciesPage.vue?c8dfb472